import moment from "moment";
import React, { useEffect, useState } from "react";
import { Spinner, Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getCenterNoc } from "../../../store/actions/centerActions/nocAction";

/*
  Every NOC of this center's students - applied by the center, the student or
  the website - with where it stands and the issued certificate.
*/
const CenterNocList = () => {
  const dispatch = useDispatch();
  const [list, setList] = useState(null);

  const load = async () => {
    setList(null);
    const rows = await dispatch(getCenterNoc());
    setList(Array.isArray(rows) ? rows : []);
  };

  useEffect(() => {
    load();
  }, []);

  const statusCell = (r) => {
    if (Number(r.status) === 1) return <span className="text-success">Issued</span>;
    if (Number(r.status) === 2) return <span className="text-danger">Rejected</span>;
    return <span className="text-info">Payment Pending</span>;
  };

  return (
    <div className="Title-box">
      <div className="row">
        <div className="col-md-6">
          <div className="BigTitle">NOC</div>
        </div>
      </div>

      <div className="mid-content-box mt-3">
        {list === null ? (
          <div className="text-center mt-4">
            <Spinner animation="border" role="status" size="lg">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Table responsive>
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Student</th>
                <th>Roll / Enroll</th>
                <th>Purpose</th>
                <th>Validity</th>
                <th>Fee</th>
                <th>Applied On</th>
                <th>Status</th>
                <th>NOC No.</th>
                <th>Valid Until</th>
                <th>Certificate</th>
              </tr>
            </thead>
            <tbody>
              {list.length === 0 ? (
                <tr>
                  <td colSpan={11}>No NOC applied for yet.</td>
                </tr>
              ) : (
                list.map((r, i) => (
                  <tr key={r.id}>
                    <td>{i + 1}</td>
                    <td>{r.student_name || "--"}</td>
                    <td>{r.roll_number || r.enrollment || "--"}</td>
                    <td>{r.purpose || "--"}</td>
                    <td>{r.validity_months ? `${r.validity_months} months` : "--"}</td>
                    <td>{r.fee != null ? `₹${Number(r.fee)}` : "--"}</td>
                    <td>{r.created_at ? moment(r.created_at).format("DD/MM/YYYY") : "--"}</td>
                    <td>{statusCell(r)}</td>
                    <td>{r.noc_number || "--"}</td>
                    <td>{r.valid_until ? moment(r.valid_until).format("DD/MM/YYYY") : "--"}</td>
                    <td>
                      {r.link ? (
                        <>
                          <a
                            href={r.link}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-sm btn-comman mr-1 mb-1"
                          >
                            Download
                          </a>
                          {r.receipt && (
                            <a
                              href={r.receipt}
                              target="_blank"
                              rel="noreferrer"
                              className="btn btn-sm btn-success mb-1"
                            >
                              Fee Slip
                            </a>
                          )}
                        </>
                      ) : Number(r.status) === 2 ? (
                        <span className="text-danger">{r.reject_reason || "Rejected"}</span>
                      ) : (
                        "--"
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
};

export default CenterNocList;
